"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  XL: 2560,
  L: 1280,
  M: 850,
  S: 720,
  XS: 160,
  XXS: 64
};